export default __webpack_public_path__ + "static/media/Group 1919.270801c8.svg";